import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
/** Which picked batches a work order starts with, per part it shares with the job's other work orders. */
export const startWorkOrderBatchesSchema = z
    .array(z.object({
    partId: requiredUuidString('Each choice must name a part.', 'Invalid part on a choice.'),
    takes: z
        .array(z.object({
        tagId: requiredUuidString('Each batch must be named.', 'Invalid batch.'),
        qty: z
            .number({ error: 'A batch amount must be a number.' })
            .positive('A batch amount must be more than zero.')
            .max(1_000_000_000, 'A batch amount is at most 1,000,000,000.'),
    }))
        .max(100, 'A part can be taken from at most 100 batches.'),
    // Only the job's last work order can put its over-pick back; the others pass it on.
    putBackExtra: z.boolean().optional().default(false),
}))
    .max(200, 'A work order can choose batches for at most 200 parts.');
//# sourceMappingURL=start-batches-input.js.map